import axios from "axios";
import Config from "../../config/";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

export function pushWorkspace(name, user_id) {
  const url = `${ROOT_URL}workspace/workspace/`;
  const request = axios.post(
    url,
    {
      name: name,
      user_id: user_id
    },
    cekAuth()
  );
  return request;
}

export function fetchWorkspace() {
  const url = `${ROOT_URL}workspace/workspace/`;
  const request = axios.get(url, cekAuth());
  return request;
}
